var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.02511 7.64551C14.0096 7.64551 18.0499 11.7141 18.0499 16.7326C18.0499 21.751 14.0093 25.8193 9.02511 25.8193C4.04097 25.8193 0 21.751 0 16.7326C0 11.7141 4.04067 7.64551 9.02511 7.64551ZM23.4376 8.1778C25.9298 8.1778 27.9501 12.0075 27.9501 16.7326H27.9504C27.9504 21.4564 25.9301 25.2873 23.4379 25.2873C20.9457 25.2873 18.9253 21.4564 18.9253 16.7326C18.9253 12.0087 20.9454 8.1778 23.4376 8.1778ZM30.4129 9.06885C31.2892 9.06885 32 12.4999 32 16.7326C32 20.9639 31.2896 24.3963 30.4129 24.3963C29.5363 24.3963 28.8262 20.9649 28.8262 16.7326C28.8262 12.5003 29.5366 9.06885 30.4129 9.06885Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.815757e2402ad4e4b43ad9e6e6703be0.svg";
export { ForwardRef as ReactComponent };